import { TextfieldOutput } from '../../team-apis/otterdam/outputs/textfield-output';
import { OutputHelper } from './output-helper';

export class TextfieldOutputHelper extends OutputHelper<TextfieldOutput> {
  override makeRandomAnswer() {
    return Math.random().toString();
  }

  getDictionaryTerms(output: TextfieldOutput) {
    const dictionaryId = this.getDictionaryId(output);
    if (dictionaryId) {
      const key = `autocomplete_dictionary_${dictionaryId}`;
      return key in window ? (window as any)?.[key] : [];
    }
    return [];
  }

  getDictionaryId(output: TextfieldOutput) {
    // fix me if you change this code
    // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition -- fix me!
    return output?.meta?.dictionary_id;
  }
}
